module.exports = __webpack_public_path__ + "static/vscode-30670b252d59bcc15c040f783d79f5e9.png";